import { useKeycloak } from '@react-keycloak/web'

let exportVar = () => ({
  keycloak: window.Keycloak as any,
})

if (process.env.NODE_ENV === 'development') {
  exportVar = useKeycloak
}

export { exportVar as useKeycloak }
